import Image from "next/image";
import { cn } from "utils";
import { useMemoizedFn } from "ahooks";
import { FormattedPrice } from "../PriceDisplay/FormattedPrice";
import { SignalLevel } from "../DetailsCommon/Forecast/constants";
import { TAListItemProps } from "./types";
import { getTALevelLabel } from "./const";
import { formatTATableTime } from "@/src/utils/taHelper";

export const TAListItem = (props: TAListItemProps) => {
  const { data, onClick } = props;
  const handleClick = useMemoizedFn(() => {
    onClick(data);
  });

  const level = data?.content?.level;
  const isStrongBuy = level === SignalLevel.STRONG_BUY;
  const isStrongSell = level === SignalLevel.STRONG_SELL;

  const tagClassName = cn(
    "body_bold_s rounded-[4px] px-[6px] py-[2px] text-center whitespace-nowrap",
    isStrongBuy &&
      "bg-background_accent1_overlay20 text-content_accent1_primary",
    isStrongSell &&
      "bg-background_accent2_overlay20 text-content_accent2_primary",
  );

  return (
    <div
      data-openreplay-label="TA · TAListItem · div"
      role="button"
      tabIndex={0}
      className="flex min-h-[52px] cursor-pointer items-center border-b border-border_white_transparent10 transition-colors md:hover:bg-background_white_overlay5"
      onClick={handleClick}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          handleClick();
        }
      }}
      key={data.id}
    >
      <div className="flex min-w-0 flex-1 items-center px-2 py-[6px]">
        <p className="body_bold_m whitespace-nowrap text-content_primary">
          {data?.created ? formatTATableTime(data.created) : "--"}
        </p>
      </div>
      <div className="flex min-w-0 flex-1 items-center gap-2 px-2 py-[6px]">
        {data?.assets?.[0]?.logo && (
          <Image
            src={data.assets[0].logo}
            alt={data.assets[0]?.symbol ?? ""}
            width={24}
            height={24}
            className="size-6 shrink-0 overflow-hidden rounded-full border-[1.25px] border-border_solid"
          />
        )}
        <p className="body_medium_m truncate text-content_primary">
          {data?.assets?.[0]?.symbol ?? "--"}
        </p>
      </div>
      <div className="flex min-w-0 flex-1 items-center px-2 py-[6px]">
        <FormattedPrice
          price={data?.content?.ta_signal?.price?.toString() ?? ""}
          className={{
            container: "body_bold_m text-content_primary",
            zeroCount: "body_medium_xs",
          }}
          currencySymbol="$"
        />
      </div>
      <div className="flex min-w-0 flex-1 items-center justify-center px-2 py-[6px]">
        {(isStrongBuy || isStrongSell) && (
          <span className={tagClassName}>{getTALevelLabel(level)}</span>
        )}
      </div>
    </div>
  );
};
